// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"PieChartTooltip_tooltip__2MRB8","title":"PieChartTooltip_title__xRcuL","content":"PieChartTooltip_content__bzpFs"};